import { TypeaheadPropertyComponentComponent } from './../../../shared/components/typeahead-property-component';
import {
  Component,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { PropertyComponentTypeahead, FiscalYear } from 'app/internal/shared/models';


@Component({
  selector: 'sp-bulk-assign-component-modal',
  templateUrl: './bulk-assign-component-modal.component.html',
  styleUrls: ['./bulk-assign-component-modal.component.scss'],
  standalone: false
})
export class BulkAssignComponentModalComponent implements AfterViewInit {
  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;
  @ViewChild('componentTypeahead', { static: true }) public componentTypeahead: TypeaheadPropertyComponentComponent;

  @Input() propertyId: string;
  @Input() fiscalYear: FiscalYear;
  @Input() selectedPhotoCount: number;

  @Output() onConfirm: EventEmitter<string> = new EventEmitter<string>();

  selectedComponent: PropertyComponentTypeahead;
  unassignFromComponents = false;

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;
  }

  show(): void {
    this.bsModal.show();
  }

  closeModal(): void {
    this.bsModal.hide();
    this.componentTypeahead.clearSearch();
    this.selectedComponent = null;
    this.unassignFromComponents = false;
  }

  setSelectedComponent(component: PropertyComponentTypeahead) {
    this.selectedComponent = component;
  }

  assignComponent() {
    if (this.unassignFromComponents) {
      this.onConfirm.emit(null);
    } else {
      this.onConfirm.emit(this.selectedComponent.propertyComponentId);
    }
    this.closeModal();
  }

  toggleUnassign() {
    this.unassignFromComponents = !this.unassignFromComponents;
  }

}
